export default "__VITE_ASSET__a49784b4__"